import { setMessageIframe } from "./redux/actions/index";

/* Public Methods Available For LRoot */
function Root(Base, store) {
  class NewRoot extends Base {

    broadcast_post_message(message) {
      store.dispatch(setMessageIframe(message));
    }

  }
  return NewRoot;
}

export default Root;
